import React, { FC } from "react";
import { BrowserRouter, Routes, Route } from "react-router";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { PostHogProvider, usePostHog } from "posthog-js/react";
import { FluentProvider as FluentThemeProvider, Toaster, makeStyles } from "@fluentui/react-components";
import { CssBaseline, ThemeProvider as MUIThemeProvider } from "@mui/material";
import { AppInsightsErrorBoundary } from "@microsoft/applicationinsights-react-js";

import { MUI_THEME, FLUENT_THEME } from "./styles/theme";
import { REACT_PLUGIN } from "../shared/config";

import Loading from "./components/Loading";
import NavigationBar from "./components/NavigationBar";
import BottomBar from "./components/BottomBar";

import SavedQueries from "./routes/SavedQueries";
import CreateQuery from "./routes/ProjectSelect";
import TemplateSelect from "./routes/TemplateSelect";
import DatasetSelect from "./routes/DatasetSelect";
import EditQuery from "./routes/SelectParameters";

const QUERY_CLIENT = new QueryClient();

const useStyles = makeStyles({
  root: {
    display: "flex",
    flexDirection: "column",
    height: "100vh",
  },
  content: {
    padding: "1rem",
    overflowY: "scroll",
    flexGrow: 100,
  },
});

export const App: FC = () => {
  const styles = useStyles();
  const posthog = usePostHog();

  return (
    <AppInsightsErrorBoundary onError={() => <h1>I believe something went wrong</h1>} appInsights={REACT_PLUGIN}>
      <PostHogProvider client={posthog}>
        <QueryClientProvider client={QUERY_CLIENT}>
          <FluentThemeProvider theme={FLUENT_THEME}>
            <MUIThemeProvider theme={MUI_THEME}>
              <CssBaseline />
              <BrowserRouter basename="taskpane.html">
                <div className={styles.root}>
                  <Toaster toasterId="global-toaster" />
                  <Loading />
                  <NavigationBar />
                  <div className={styles.content}>
                    <Routes>
                      <Route path="/" element={<SavedQueries />} />
                      <Route path="/create" element={<CreateQuery />} />
                      <Route path="/create/template" element={<TemplateSelect />} />
                      <Route path="/create/dataset" element={<DatasetSelect />} />
                      <Route path="/edit" element={<EditQuery />} />
                    </Routes>
                  </div>
                  <BottomBar />
                </div>
              </BrowserRouter>
            </MUIThemeProvider>
          </FluentThemeProvider>
        </QueryClientProvider>
      </PostHogProvider>
    </AppInsightsErrorBoundary>
  );
};
